package pt.at.oss.kotlin.core.enumeration

/**
 * Countries catalog used in OSS
 *
 * Note: Updated using MOSS' Tgtpais*.xml queries. More info in 'README-countries-catalog.md'.
 * <p>
 * Created by Pedro Alfaiate on 11/05/2020.
 */
enum class Country(
    val isInEU: Boolean,
    override val codeA2: String,
    val labelPT: String,
    val labelEN: String
) : WithCodeA2 {

    ANDORRA(
        isInEU = false,
        codeA2 = "AD",
        labelPT = "ANDORRA",
        labelEN = "ANDORRA, PRINCIPALITY OF"
    ),
    UNITED_ARAB_EMIRATES(
        isInEU = false,
        codeA2 = "AE",
        labelPT = "EMIRATOS ARABES UNIDOS",
        labelEN = "UNITED ARAB EMIRATES (WAS TRUCIAL STATES)"
    ),
    AFGHANISTAN(
        isInEU = false,
        codeA2 = "AF",
        labelPT = "AFEGANISTAO",
        labelEN = "AFGHANISTAN"
    ),
    ANTIGUA_AND_BARBUDA(
        isInEU = false,
        codeA2 = "AG",
        labelPT = "ANTIGUA E BARBUDA",
        labelEN = "ANTIGUA AND BARBUDA"
    ),
    ANGUILLA(
        isInEU = false,
        codeA2 = "AI",
        labelPT = "ANGUILA",
        labelEN = "ANGUILLA"
    ),
    ALBANIA(
        isInEU = false,
        codeA2 = "AL",
        labelPT = "ALBANIA",
        labelEN = "ALBANIA, PEOPLE'S SOCIALIST REPUBLIC OF"
    ),
    ARMENIA(
        isInEU = false,
        codeA2 = "AM",
        labelPT = "ARMENIA",
        labelEN = "ARMENIA"
    ),
    NETHERLANDS_ANTILLES(
        isInEU = false,
        codeA2 = "AN",
        labelPT = "ANTILHAS HOLANDESAS",
        labelEN = "NETHERLANDS ANTILLES"
    ),
    ANGOLA(
        isInEU = false,
        codeA2 = "AO",
        labelPT = "REPUBLICA DE ANGOLA",
        labelEN = "ANGOLA, REPUBLIC OF"
    ),
    ANTARCTICA(
        isInEU = false,
        codeA2 = "AQ",
        labelPT = "ANTARCTICA",
        labelEN = "ANTARCTICA (THE TERRITORY SOUTH OF 60 DEG S)"
    ),
    ARGENTINA(
        isInEU = false,
        codeA2 = "AR",
        labelPT = "ARGENTINA",
        labelEN = "ARGENTINA, ARGENTINE REPUBLIC"
    ),
    AMERICAN_SAMOA(
        isInEU = false,
        codeA2 = "AS",
        labelPT = "SAMOA AMERICANA",
        labelEN = "AMERICAN SAMOA"
    ),
    AUSTRALIA(
        isInEU = false,
        codeA2 = "AU",
        labelPT = "AUSTRALIA",
        labelEN = "AUSTRALIA, COMMONWEALTH OF"
    ),
    ARUBA(
        isInEU = false,
        codeA2 = "AW",
        labelPT = "ARUBA",
        labelEN = "ARUBA"
    ),
    AZERBAIJAN(
        isInEU = false,
        codeA2 = "AZ",
        labelPT = "AZERBAIJAO",
        labelEN = "AZERBAIJAN, REPUBLIC OF"
    ),
    BOSNIA_AND_HERZEGOVINA(
        isInEU = false,
        codeA2 = "BA",
        labelPT = "BOSNIA E HERZEGOVINA",
        labelEN = "BOSNIA AND HERZEGOVINA"
    ),
    BARBADOS(
        isInEU = false,
        codeA2 = "BB",
        labelPT = "BARBADOS",
        labelEN = "BARBADOS"
    ),
    BANGLADESH(
        isInEU = false,
        codeA2 = "BD",
        labelPT = "BANGLADESH",
        labelEN = "BANGLADESH, PEOPLE'S REPUBLIC OF"
    ),
    BURKINA_FASO(
        isInEU = false,
        codeA2 = "BF",
        labelPT = "BURKINA FASO",
        labelEN = "BURKINA FASO (WAS UPPER VOLTA)"
    ),
    BAHRAIN(
        isInEU = false,
        codeA2 = "BH",
        labelPT = "BAREM",
        labelEN = "BAHRAIN, KINGDOM OF"
    ),
    BURUNDI(
        isInEU = false,
        codeA2 = "BI",
        labelPT = "BURUNDI",
        labelEN = "BURUNDI, REPUBLIC OF"
    ),
    BENIN(
        isInEU = false,
        codeA2 = "BJ",
        labelPT = "BENIN",
        labelEN = "BENIN (WAS DAHOMEY), PEOPLE'S REPUBLIC OF"
    ),
    SAINT_BARTHELEMY(
        isInEU = false,
        codeA2 = "BL",
        labelPT = "SÃO BARTOLOMEU",
        labelEN = "SAINT BARTHÉLEMY"
    ),
    BERMUDA(
        isInEU = false,
        codeA2 = "BM",
        labelPT = "BERMUDA",
        labelEN = "BERMUDA"
    ),
    BRUNEI_DARUSSALAM(
        isInEU = false,
        codeA2 = "BN",
        labelPT = "BRUNEI DARUSSALAM",
        labelEN = "BRUNEI DARUSSALAM"
    ),
    BOLIVIA(
        isInEU = false,
        codeA2 = "BO",
        labelPT = "BOLIVIA",
        labelEN = "BOLIVIA, REPUBLIC OF"
    ),
    BONAIRE_SAINT_EUSTATIUS_E_SABA(
        isInEU = false,
        codeA2 = "BQ",
        labelPT = "BONAIRE, SAINT EUSTATIUS E SABA",
        labelEN = "BONAIRE, SAINT EUSTATIUS E SABA"
    ),
    BRAZIL(
        isInEU = false,
        codeA2 = "BR",
        labelPT = "BRASIL",
        labelEN = "BRAZIL, FEDERATIVE REPUBLIC OF"
    ),
    BAHAMAS(
        isInEU = false,
        codeA2 = "BS",
        labelPT = "BAHAMAS",
        labelEN = "BAHAMAS, COMMONWEALTH OF THE"
    ),
    BHUTAN(
        isInEU = false,
        codeA2 = "BT",
        labelPT = "BUTAO",
        labelEN = "BHUTAN, KINGDOM OF"
    ),
    BOUVET_ISLAND(
        isInEU = false,
        codeA2 = "BV",
        labelPT = "ILHAS BOUVET",
        labelEN = "BOUVET ISLAND (BOUVETOYA)"
    ),
    BOTSWANA(
        isInEU = false,
        codeA2 = "BW",
        labelPT = "BOTSWANA",
        labelEN = "BOTSWANA, REPUBLIC OF"
    ),
    BELARUS(
        isInEU = false,
        codeA2 = "BY",
        labelPT = "BIELORRUSSIA",
        labelEN = "BELARUS"
    ),
    BELIZE(
        isInEU = false,
        codeA2 = "BZ",
        labelPT = "BELIZE",
        labelEN = "BELIZE"
    ),
    CANADA(
        isInEU = false,
        codeA2 = "CA",
        labelPT = "CANADA",
        labelEN = "CANADA"
    ),
    COCOS_KEELING_ISLANDS(
        isInEU = false,
        codeA2 = "CC",
        labelPT = "ILHAS COCOS O KEELING",
        labelEN = "COCOS (KEELING) ISLANDS"
    ),
    CONGO_DEMOCRATIC_REPUBLIC(
        isInEU = false,
        codeA2 = "CD",
        labelPT = "CONGO (REPUBLICA DEMOCRATICA DO)",
        labelEN = "CONGO, DEMOCRATIC REPUBLIC OF (WAS ZAIRE)"
    ),
    CENTRAL_AFRICAN_REPUBLIC(
        isInEU = false,
        codeA2 = "CF",
        labelPT = "CENTRO-AFRICANA (REPUBLICA)",
        labelEN = "CENTRAL AFRICAN REPUBLIC"
    ),
    CONGO_PEOPLE_REPUBLIC(
        isInEU = false,
        codeA2 = "CG",
        labelPT = "CONGO",
        labelEN = "CONGO, PEOPLE'S REPUBLIC OF"
    ),
    SWITZERLAND(
        isInEU = false,
        codeA2 = "CH",
        labelPT = "SUICA",
        labelEN = "SWITZERLAND, SWISS CONFEDERATION"
    ),
    IVORY_COAST(
        isInEU = false,
        codeA2 = "CI",
        labelPT = "COSTA DO MARFIM",
        labelEN = "COTE D'IVOIRE, IVORY COAST, REPUBLIC OF THE"
    ),
    COOK_ISLANDS(
        isInEU = false,
        codeA2 = "CK",
        labelPT = "ILHAS COOK",
        labelEN = "COOK ISLANDS"
    ),
    CHILE(
        isInEU = false,
        codeA2 = "CL",
        labelPT = "CHILE",
        labelEN = "CHILE, REPUBLIC OF"
    ),
    CAMEROON(
        isInEU = false,
        codeA2 = "CM",
        labelPT = "CAMAROES",
        labelEN = "CAMEROON, UNITED REPUBLIC OF"
    ),
    CHINA(
        isInEU = false,
        codeA2 = "CN",
        labelPT = "CHINA",
        labelEN = "CHINA, PEOPLE'S REPUBLIC OF"
    ),
    COLOMBIA(
        isInEU = false,
        codeA2 = "CO",
        labelPT = "COLOMBIA",
        labelEN = "COLOMBIA, REPUBLIC OF"
    ),
    COSTA_RICA(
        isInEU = false,
        codeA2 = "CR",
        labelPT = "COSTA RICA",
        labelEN = "COSTA RICA, REPUBLIC OF"
    ),
    CUBA(
        isInEU = false,
        codeA2 = "CU",
        labelPT = "CUBA",
        labelEN = "CUBA, REPUBLIC OF"
    ),
    CAPE_VERDE(
        isInEU = false,
        codeA2 = "CV",
        labelPT = "CABO VERDE",
        labelEN = "CAPE VERDE, REPUBLIC OF"
    ),
    CURACAO(
        isInEU = false,
        codeA2 = "CW",
        labelPT = "CURAÇAO",
        labelEN = "CURAÇAO"
    ),
    CHRISTMAS_ISLAND(
        isInEU = false,
        codeA2 = "CX",
        labelPT = "ILHAS NATAL",
        labelEN = "CHRISTMAS ISLAND"
    ),
    DJIBOUTI(
        isInEU = false,
        codeA2 = "DJ",
        labelPT = "JIBUTI",
        labelEN = "DJIBOUTI, REPUBLIC OF (WAS FRENCH AFARS AND ISSAS)"
    ),
    DOMINICA(
        isInEU = false,
        codeA2 = "DM",
        labelPT = "DOMINICA",
        labelEN = "DOMINICA, COMMONWEALTH OF"
    ),
    DOMINICAN_REPUBLIC(
        isInEU = false,
        codeA2 = "DO",
        labelPT = "REPUBLICA DOMINICANA",
        labelEN = "DOMINICAN REPUBLIC"
    ),
    ALGERIA(
        isInEU = false,
        codeA2 = "DZ",
        labelPT = "ARGELIA",
        labelEN = "ALGERIA, PEOPLE'S DEMOCRATIC REPUBLIC OF"
    ),
    ECUADOR(
        isInEU = false,
        codeA2 = "EC",
        labelPT = "EQUADOR",
        labelEN = "ECUADOR, REPUBLIC OF"
    ),
    EGYPT(
        isInEU = false,
        codeA2 = "EG",
        labelPT = "EGIPTO",
        labelEN = "EGYPT, ARAB REPUBLIC OF"
    ),
    WESTERN_SAHARA(
        isInEU = false,
        codeA2 = "EH",
        labelPT = "SARA OCIDENTAL",
        labelEN = "WESTERN SAHARA (WAS SPANISH SAHARA)"
    ),
    ERITREA(
        isInEU = false,
        codeA2 = "ER",
        labelPT = "ERITREIA",
        labelEN = "ERITREA"
    ),
    ETHIOPIA(
        isInEU = false,
        codeA2 = "ET",
        labelPT = "ETIOPIA",
        labelEN = "ETHIOPIA"
    ),
    FIJI(
        isInEU = false,
        codeA2 = "FJ",
        labelPT = "ILHAS FIJI",
        labelEN = "FIJI, REPUBLIC OF THE FIJI ISLANDS"
    ),
    FALKLAND_ISLANDS(
        isInEU = false,
        codeA2 = "FK",
        labelPT = "ILHAS FALKLAND (MALVINAS)",
        labelEN = "FALKLAND ISLANDS (MALVINAS)"
    ),
    MICRONESIA(
        isInEU = false,
        codeA2 = "FM",
        labelPT = "MICRONESIA (ESTADOS FEDERADOS DA)",
        labelEN = "MICRONESIA, FEDERATED STATES OF"
    ),
    FAEROE_ISLANDS(
        isInEU = false,
        codeA2 = "FO",
        labelPT = "ILHAS FAROE",
        labelEN = "FAEROE ISLANDS"
    ),
    GABON(
        isInEU = false,
        codeA2 = "GA",
        labelPT = "GABAO",
        labelEN = "GABON, GABONESE REPUBLIC"
    ),
    GRENADA(
        isInEU = false,
        codeA2 = "GD",
        labelPT = "GRANADA",
        labelEN = "GRENADA"
    ),
    GEORGIA(
        isInEU = false,
        codeA2 = "GE",
        labelPT = "GEORGIA",
        labelEN = "GEORGIA"
    ),
    FRENCH_GUIANA(
        isInEU = false,
        codeA2 = "GF",
        labelPT = "GUIANA FRANCESA",
        labelEN = "FRENCH GUIANA"
    ),
    GUERNSEY(
        isInEU = false,
        codeA2 = "GG",
        labelPT = "GUERNSEY",
        labelEN = "GUERNSEY"
    ),
    GHANA(
        isInEU = false,
        codeA2 = "GH",
        labelPT = "GANA",
        labelEN = "GHANA, REPUBLIC OF"
    ),
    GIBRALTAR(
        isInEU = false,
        codeA2 = "GI",
        labelPT = "GIBRALTAR",
        labelEN = "GIBRALTAR"
    ),
    GREENLAND(
        isInEU = false,
        codeA2 = "GL",
        labelPT = "GRONELANDIA",
        labelEN = "GREENLAND"
    ),
    GAMBIA(
        isInEU = false,
        codeA2 = "GM",
        labelPT = "GAMBIA",
        labelEN = "GAMBIA, REPUBLIC OF THE"
    ),
    GUINEA(
        isInEU = false,
        codeA2 = "GN",
        labelPT = "GUINE",
        labelEN = "GUINEA, REVOLUTIONARY PEOPLE'S REP'C OF"
    ),
    GUADALOUPE(
        isInEU = false,
        codeA2 = "GP",
        labelPT = "GUADALUPE",
        labelEN = "GUADALOUPE"
    ),
    EQUATORIAL_GUINEA(
        isInEU = false,
        codeA2 = "GQ",
        labelPT = "GUINE EQUATORIAL",
        labelEN = "EQUATORIAL GUINEA, REPUBLIC OF"
    ),
    SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS(
        isInEU = false,
        codeA2 = "GS",
        labelPT = "GEORGIA DO SUL E ILHAS SANDWICH",
        labelEN = "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS"
    ),
    GUATEMALA(
        isInEU = false,
        codeA2 = "GT",
        labelPT = "GUATEMALA",
        labelEN = "GUATEMALA, REPUBLIC OF"
    ),
    GUAM(
        isInEU = false,
        codeA2 = "GU",
        labelPT = "GUAM",
        labelEN = "GUAM"
    ),
    GUINEA_BISSAU(
        isInEU = false,
        codeA2 = "GW",
        labelPT = "GUINE-BISSAU",
        labelEN = "GUINEA-BISSAU, REPUBLIC OF (WAS PORTUGUESE GUINEA)"
    ),
    GUYANA(
        isInEU = false,
        codeA2 = "GY",
        labelPT = "GUIANA",
        labelEN = "GUYANA, REPUBLIC OF"
    ),
    HONG_KONG(
        isInEU = false,
        codeA2 = "HK",
        labelPT = "HONG KONG",
        labelEN = "HONG KONG, SPECIAL ADMINISTRATIVE REGION OF CHINA"
    ),
    HEARD_AND_MCDONALD_ISLANDS(
        isInEU = false,
        codeA2 = "HM",
        labelPT = "ILHAS HEARD E ILHAS MCDONALD",
        labelEN = "HEARD AND MCDONALD ISLANDS"
    ),
    HONDURAS(
        isInEU = false,
        codeA2 = "HN",
        labelPT = "HONDURAS",
        labelEN = "HONDURAS, REPUBLIC OF"
    ),
    HAITI(
        isInEU = false,
        codeA2 = "HT",
        labelPT = "HAITI",
        labelEN = "HAITI, REPUBLIC OF"
    ),
    INDONESIA(
        isInEU = false,
        codeA2 = "ID",
        labelPT = "INDONESIA",
        labelEN = "INDONESIA, REPUBLIC OF"
    ),
    ISRAEL(
        isInEU = false,
        codeA2 = "IL",
        labelPT = "ISRAEL",
        labelEN = "ISRAEL, STATE OF"
    ),
    INDIA(
        isInEU = false,
        codeA2 = "IN",
        labelPT = "INDIA",
        labelEN = "INDIA, REPUBLIC OF"
    ),
    BRITISH_INDIAN_OCEAN_TERRITORY(
        isInEU = false,
        codeA2 = "IO",
        labelPT = "TERRITORIO BRITANICO DO OCEANO INDICO",
        labelEN = "BRITISH INDIAN OCEAN TERRITORY (CHAGOS ARCHIPELAGO)"
    ),
    IRAQ(
        isInEU = false,
        codeA2 = "IQ",
        labelPT = "IRAQUE",
        labelEN = "IRAQ, REPUBLIC OF"
    ),
    IRAN(
        isInEU = false,
        codeA2 = "IR",
        labelPT = "IRAO (REPUBLICA ISLAMICA)",
        labelEN = "IRAN, ISLAMIC REPUBLIC OF"
    ),
    ICELAND(
        isInEU = false,
        codeA2 = "IS",
        labelPT = "ISLANDIA",
        labelEN = "ICELAND, REPUBLIC OF"
    ),
    JERSEY(
        isInEU = false,
        codeA2 = "JE",
        labelPT = "JERSEY",
        labelEN = "JERSEY"
    ),
    JAMAICA(
        isInEU = false,
        codeA2 = "JM",
        labelPT = "JAMAICA",
        labelEN = "JAMAICA"
    ),
    JORDAN(
        isInEU = false,
        codeA2 = "JO",
        labelPT = "JORDANIA",
        labelEN = "JORDAN, HASHEMITE KINGDOM OF"
    ),
    JAPAN(
        isInEU = false,
        codeA2 = "JP",
        labelPT = "JAPAO",
        labelEN = "JAPAN"
    ),
    KENYA(
        isInEU = false,
        codeA2 = "KE",
        labelPT = "KENYA",
        labelEN = "KENYA, REPUBLIC OF"
    ),
    KYRGYZ_REPUBLIC(
        isInEU = false,
        codeA2 = "KG",
        labelPT = "QUIRGUIZISTAO",
        labelEN = "KYRGYZ REPUBLIC"
    ),
    CAMBODIA(
        isInEU = false,
        codeA2 = "KH",
        labelPT = "CAMBOJA",
        labelEN = "CAMBODIA, KINGDOM OF (WAS KHMER REPUBLIC/KAMPUCHEA)"
    ),
    KIRIBATI(
        isInEU = false,
        codeA2 = "KI",
        labelPT = "KIRIBATI",
        labelEN = "KIRIBATI, REPUBLIC OF (WAS GILBERT ISLANDS)"
    ),
    COMOROS(
        isInEU = false,
        codeA2 = "KM",
        labelPT = "COMORES",
        labelEN = "COMOROS, FEDERAL AND ISLAMIC REPUBLIC OF"
    ),
    ST_KITTS_AND_NEVIS(
        isInEU = false,
        codeA2 = "KN",
        labelPT = "SAO CRISTOVAO E NEVIS",
        labelEN = "ST. KITTS AND NEVIS"
    ),
    KOREA_DEMOCRATIC_PEOPLE_REPUBLIC(
        isInEU = false,
        codeA2 = "KP",
        labelPT = "COREIA (REPUBLICA POPULAR DEMOCRATICA DA)",
        labelEN = "KOREA, DEMOCRATIC PEOPLE'S REPUBLIC OF"
    ),
    KOREA_REPUBLIC_OF(
        isInEU = false,
        codeA2 = "KR",
        labelPT = "COREIA (REPUBLICA DA)",
        labelEN = "KOREA, REPUBLIC OF"
    ),
    KUWAIT(
        isInEU = false,
        codeA2 = "KW",
        labelPT = "KUWAIT",
        labelEN = "KUWAIT, STATE OF"
    ),
    CAYMAN_ISLANDS(
        isInEU = false,
        codeA2 = "KY",
        labelPT = "ILHAS CAIMAO",
        labelEN = "CAYMAN ISLANDS"
    ),
    KAZAKHSTAN(
        isInEU = false,
        codeA2 = "KZ",
        labelPT = "CAZAQUISTAO",
        labelEN = "KAZAKHSTAN, REPUBLIC OF"
    ),
    LAO_PEOPLE_DEMOCRATIC_REPUBLIC(
        isInEU = false,
        codeA2 = "LA",
        labelPT = "LAOS (REPUBLICA POPULAR DEMOCRATICA DO)",
        labelEN = "LAO PEOPLE'S DEMOCRATIC REPUBLIC"
    ),
    LEBANON(
        isInEU = false,
        codeA2 = "LB",
        labelPT = "LIBANO",
        labelEN = "LEBANON, LEBANESE REPUBLIC"
    ),
    ST_LUCIA(
        isInEU = false,
        codeA2 = "LC",
        labelPT = "SANTA LUCIA",
        labelEN = "ST. LUCIA"
    ),
    LIECHTENSTEIN(
        isInEU = false,
        codeA2 = "LI",
        labelPT = "LIECHTENSTEIN",
        labelEN = "LIECHTENSTEIN, PRINCIPALITY OF"
    ),
    SRI_LANKA(
        isInEU = false,
        codeA2 = "LK",
        labelPT = "SRI LANKA",
        labelEN = "SRI LANKA, DEMOCRATIC SOCIALIST REPUBLIC OF (WAS CEYLON)"
    ),
    LIBERIA(
        isInEU = false,
        codeA2 = "LR",
        labelPT = "LIBERIA",
        labelEN = "LIBERIA, REPUBLIC OF"
    ),
    LESOTHO(
        isInEU = false,
        codeA2 = "LS",
        labelPT = "LESOTO",
        labelEN = "LESOTHO, KINGDOM OF"
    ),
    LIBYAN_ARAB_JAMAHIRIYA(
        isInEU = false,
        codeA2 = "LY",
        labelPT = "LIBIA (JAMAHIRIYA ARABE DA)",
        labelEN = "LIBYAN ARAB JAMAHIRIYA"
    ),
    MOROCCO(
        isInEU = false,
        codeA2 = "MA",
        labelPT = "MARROCOS",
        labelEN = "MOROCCO, KINGDOM OF"
    ),
    MOLDOVA(
        isInEU = false,
        codeA2 = "MD",
        labelPT = "MOLDOVA (REPUBLICA DE)",
        labelEN = "MOLDOVA, REPUBLIC OF"
    ),
    MONTENEGRO(
        isInEU = false,
        codeA2 = "ME",
        labelPT = "MONTENEGRO",
        labelEN = "MONTENEGRO"
    ),
    SAINT_MARTIN_FRENCH_PART(
        isInEU = false,
        codeA2 = "MF",
        labelPT = "SAINT MARTIN (FRENCH PART)",
        labelEN = "SAINT MARTIN (FRENCH PART)"
    ),
    MADAGASCAR(
        isInEU = false,
        codeA2 = "MG",
        labelPT = "MADAGASCAR",
        labelEN = "MADAGASCAR, REPUBLIC OF"
    ),
    MARSHALL_ISLANDS(
        isInEU = false,
        codeA2 = "MH",
        labelPT = "ILHAS MARSHALL",
        labelEN = "MARSHALL ISLANDS"
    ),
    MACEDONIA_FORMER_YUGOSLAV_REPUBLIC(
        isInEU = false,
        codeA2 = "MK",
        labelPT = "MACEDONIA (ANTIGA REPUBLICA JUGOSLAVA DA)",
        labelEN = "MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF"
    ),
    MALI(
        isInEU = false,
        codeA2 = "ML",
        labelPT = "MALI",
        labelEN = "MALI, REPUBLIC OF"
    ),
    MYANMAR(
        isInEU = false,
        codeA2 = "MM",
        labelPT = "MYANMAR",
        labelEN = "MYANMAR (WAS BURMA)"
    ),
    MONGOLIA(
        isInEU = false,
        codeA2 = "MN",
        labelPT = "MONGOLIA",
        labelEN = "MONGOLIA, MONGOLIAN PEOPLE'S REPUBLIC"
    ),
    MACAO(
        isInEU = false,
        codeA2 = "MO",
        labelPT = "MACAU",
        labelEN = "MACAO, SPECIAL ADMINISTRATIVE REGION OF CHINA"
    ),
    NORTHERN_MARIANA_ISLANDS(
        isInEU = false,
        codeA2 = "MP",
        labelPT = "ILHAS MARIANAS DO NORTE",
        labelEN = "NORTHERN MARIANA ISLANDS"
    ),
    MARTINIQUE(
        isInEU = false,
        codeA2 = "MQ",
        labelPT = "MARTINICA",
        labelEN = "MARTINIQUE"
    ),
    MAURITANIA(
        isInEU = false,
        codeA2 = "MR",
        labelPT = "MAURITANIA",
        labelEN = "MAURITANIA, ISLAMIC REPUBLIC OF"
    ),
    MONTSERRAT(
        isInEU = false,
        codeA2 = "MS",
        labelPT = "MONSERRATE",
        labelEN = "MONTSERRAT"
    ),
    MAURITIUS(
        isInEU = false,
        codeA2 = "MU",
        labelPT = "MAURICIAS",
        labelEN = "MAURITIUS"
    ),
    MALDIVES(
        isInEU = false,
        codeA2 = "MV",
        labelPT = "MALDIVAS",
        labelEN = "MALDIVES, REPUBLIC OF"
    ),
    MALAWI(
        isInEU = false,
        codeA2 = "MW",
        labelPT = "MALAWI",
        labelEN = "MALAWI, REPUBLIC OF"
    ),
    MEXICO(
        isInEU = false,
        codeA2 = "MX",
        labelPT = "MEXICO",
        labelEN = "MEXICO, UNITED MEXICAN STATES"
    ),
    MALAYSIA(
        isInEU = false,
        codeA2 = "MY",
        labelPT = "MALASIA",
        labelEN = "MALAYSIA"
    ),
    MOZAMBIQUE(
        isInEU = false,
        codeA2 = "MZ",
        labelPT = "MOCAMBIQUE",
        labelEN = "MOZAMBIQUE, PEOPLE'S REPUBLIC OF"
    ),
    NAMIBIA(
        isInEU = false,
        codeA2 = "NA",
        labelPT = "NAMIBIA",
        labelEN = "NAMIBIA"
    ),
    NEW_CALEDONIA(
        isInEU = false,
        codeA2 = "NC",
        labelPT = "NOVA CALEDONIA",
        labelEN = "NEW CALEDONIA"
    ),
    NIGER(
        isInEU = false,
        codeA2 = "NE",
        labelPT = "NIGER",
        labelEN = "NIGER, REPUBLIC OF THE"
    ),
    NORFOLK_ISLAND(
        isInEU = false,
        codeA2 = "NF",
        labelPT = "ILHAS NORFOLK",
        labelEN = "NORFOLK ISLAND"
    ),
    NIGERIA(
        isInEU = false,
        codeA2 = "NG",
        labelPT = "NIGERIA",
        labelEN = "NIGERIA, FEDERAL REPUBLIC OF"
    ),
    NICARAGUA(
        isInEU = false,
        codeA2 = "NI",
        labelPT = "NICARAGUA",
        labelEN = "NICARAGUA, REPUBLIC OF"
    ),
    NORWAY(
        isInEU = false,
        codeA2 = "NO",
        labelPT = "NORUEGA",
        labelEN = "NORWAY, KINGDOM OF"
    ),
    NEPAL(
        isInEU = false,
        codeA2 = "NP",
        labelPT = "NEPAL",
        labelEN = "NEPAL, KINGDOM OF"
    ),
    NAURU(
        isInEU = false,
        codeA2 = "NR",
        labelPT = "NAURU",
        labelEN = "NAURU, REPUBLIC OF"
    ),
    NIUE(
        isInEU = false,
        codeA2 = "NU",
        labelPT = "NIUE",
        labelEN = "NIUE, REPUBLIC OF"
    ),
    NEW_ZEALAND(
        isInEU = false,
        codeA2 = "NZ",
        labelPT = "NOVA ZELANDIA",
        labelEN = "NEW ZEALAND"
    ),
    OMAN(
        isInEU = false,
        codeA2 = "OM",
        labelPT = "OMA",
        labelEN = "OMAN, SULTANATE OF (WAS MUSCAT AND OMAN)"
    ),
    PANAMA(
        isInEU = false,
        codeA2 = "PA",
        labelPT = "PANAMA",
        labelEN = "PANAMA, REPUBLIC OF"
    ),
    PERU(
        isInEU = false,
        codeA2 = "PE",
        labelPT = "PERU",
        labelEN = "PERU, REPUBLIC OF"
    ),
    FRENCH_POLYNESIA(
        isInEU = false,
        codeA2 = "PF",
        labelPT = "POLINESIA FRANCESA",
        labelEN = "FRENCH POLYNESIA"
    ),
    PAPUA_NEW_GUINEA(
        isInEU = false,
        codeA2 = "PG",
        labelPT = "PAPUASIA-NOVA GUINE",
        labelEN = "PAPUA NEW GUINEA"
    ),
    PHILIPPINES(
        isInEU = false,
        codeA2 = "PH",
        labelPT = "FILIPINAS",
        labelEN = "PHILIPPINES, REPUBLIC OF THE"
    ),
    PAKISTAN(
        isInEU = false,
        codeA2 = "PK",
        labelPT = "PAQUISTAO",
        labelEN = "PAKISTAN, ISLAMIC REPUBLIC OF"
    ),
    ST_PIERRE_AND_MIQUELON(
        isInEU = false,
        codeA2 = "PM",
        labelPT = "SAO PEDRO E MIQUELON",
        labelEN = "ST. PIERRE AND MIQUELON"
    ),
    PITCAIRN_ISLAND(
        isInEU = false,
        codeA2 = "PN",
        labelPT = "PITCAIRN",
        labelEN = "PITCAIRN ISLAND"
    ),
    PUERTO_RICO(
        isInEU = false,
        codeA2 = "PR",
        labelPT = "PORTO RICO",
        labelEN = "PUERTO RICO"
    ),
    PALESTINIAN_TERRITORY(
        isInEU = false,
        codeA2 = "PS",
        labelPT = "TERRITORIO PALESTINIANO OCUPADO",
        labelEN = "PALESTINIAN TERRITORY, OCCUPIED"
    ),
    PALAU(
        isInEU = false,
        codeA2 = "PW",
        labelPT = "PALAU",
        labelEN = "PALAU"
    ),
    PARAGUAY(
        isInEU = false,
        codeA2 = "PY",
        labelPT = "PARAGUAI",
        labelEN = "PARAGUAY, REPUBLIC OF"
    ),
    QATAR(
        isInEU = false,
        codeA2 = "QA",
        labelPT = "CATAR",
        labelEN = "QATAR, STATE OF"
    ),
    REUNION(
        isInEU = false,
        codeA2 = "RE",
        labelPT = "REUNIAO",
        labelEN = "REUNION"
    ),
    SERBIA(
        isInEU = false,
        codeA2 = "RS",
        labelPT = "SERVIA",
        labelEN = "SERBIA"
    ),
    RUSSIAN_FEDERATION(
        isInEU = false,
        codeA2 = "RU",
        labelPT = "RUSSIA (FEDERACAO DA)",
        labelEN = "RUSSIAN FEDERATION"
    ),
    RWANDA(
        isInEU = false,
        codeA2 = "RW",
        labelPT = "RUANDA",
        labelEN = "RWANDA, RWANDESE REPUBLIC"
    ),
    SAUDI_ARABIA(
        isInEU = false,
        codeA2 = "SA",
        labelPT = "ARABIA SAUDITA",
        labelEN = "SAUDI ARABIA, KINGDOM OF"
    ),
    SOLOMON_ISLANDS(
        isInEU = false,
        codeA2 = "SB",
        labelPT = "ILHAS SALOMAO",
        labelEN = "SOLOMON ISLANDS (WAS BRITISH SOLOMON ISLANDS)"
    ),
    SEYCHELLES(
        isInEU = false,
        codeA2 = "SC",
        labelPT = "SEYCHELLES",
        labelEN = "SEYCHELLES, REPUBLIC OF"
    ),
    SUDAN(
        isInEU = false,
        codeA2 = "SD",
        labelPT = "SUDAN",
        labelEN = "SUDAN"
    ),
    SINGAPORE(
        isInEU = false,
        codeA2 = "SG",
        labelPT = "SINGAPURA",
        labelEN = "SINGAPORE, REPUBLIC OF"
    ),
    ST_HELENA(
        isInEU = false,
        codeA2 = "SH",
        labelPT = "SANTA HELENA",
        labelEN = "ST. HELENA"
    ),
    SVALBARD_JAN_MAYEN_ISLANDS(
        isInEU = false,
        codeA2 = "SJ",
        labelPT = "SVALBARD E A ILHA DE JAN MAYEN",
        labelEN = "SVALBARD & JAN MAYEN ISLANDS"
    ),
    SIERRA_LEONE(
        isInEU = false,
        codeA2 = "SL",
        labelPT = "SERRA LEOA",
        labelEN = "SIERRA LEONE, REPUBLIC OF"
    ),
    SAN_MARINO(
        isInEU = false,
        codeA2 = "SM",
        labelPT = "SAO MARINO",
        labelEN = "SAN MARINO, REPUBLIC OF"
    ),
    SENEGAL(
        isInEU = false,
        codeA2 = "SN",
        labelPT = "SENEGAL",
        labelEN = "SENEGAL, REPUBLIC OF"
    ),
    SOMALIA(
        isInEU = false,
        codeA2 = "SO",
        labelPT = "SOMALIA",
        labelEN = "SOMALIA, SOMALI REPUBLIC"
    ),
    SURINAME(
        isInEU = false,
        codeA2 = "SR",
        labelPT = "SURINAME",
        labelEN = "SURINAME, REPUBLIC OF"
    ),
    SOUTH_SUDAN(
        isInEU = false,
        codeA2 = "SS",
        labelPT = "SOUTH SUDAN",
        labelEN = "SOUTH SUDAN"
    ),
    SAO_TOME_AND_PRINCIPE(
        isInEU = false,
        codeA2 = "ST",
        labelPT = "SAO TOME E PRINCIPE",
        labelEN = "SAO TOME AND PRINCIPE, DEMOCRATIC REPUBLIC OF"
    ),
    EL_SALVADOR(
        isInEU = false,
        codeA2 = "SV",
        labelPT = "EL SALVADOR",
        labelEN = "EL SALVADOR, REPUBLIC OF"
    ),
    SINT_MAARTEN(
        isInEU = false,
        codeA2 = "SX",
        labelPT = "SINT MAARTEN",
        labelEN = "SINT MAARTEN"
    ),
    SYRIAN_ARAB_REPUBLIC(
        isInEU = false,
        codeA2 = "SY",
        labelPT = "SIRIA (REPUBLICA ARABE DA)",
        labelEN = "SYRIAN ARAB REPUBLIC"
    ),
    SWAZILAND(
        isInEU = false,
        codeA2 = "SZ",
        labelPT = "SUAZILANDIA",
        labelEN = "SWAZILAND, KINGDOM OF"
    ),
    TURKS_AND_CAICOS_ISLANDS(
        isInEU = false,
        codeA2 = "TC",
        labelPT = "TURCOS E CAICOS (ILHAS)",
        labelEN = "TURKS AND CAICOS ISLANDS"
    ),
    CHAD(
        isInEU = false,
        codeA2 = "TD",
        labelPT = "CHADE",
        labelEN = "CHAD, REPUBLIC OF"
    ),
    FRENCH_SOUTHERN_TERRITORIES(
        isInEU = false,
        codeA2 = "TF",
        labelPT = "TERRITORIOS FRANCESES DO SUL",
        labelEN = "FRENCH SOUTHERN TERRITORIES"
    ),
    TOGO(
        isInEU = false,
        codeA2 = "TG",
        labelPT = "TOGO",
        labelEN = "TOGO, TOGOLESE REPUBLIC"
    ),
    THAILAND(
        isInEU = false,
        codeA2 = "TH",
        labelPT = "TAILANDIA",
        labelEN = "THAILAND, KINGDOM OF"
    ),
    TAJIKISTAN(
        isInEU = false,
        codeA2 = "TJ",
        labelPT = "TAJIQUISTAO",
        labelEN = "TAJIKISTAN"
    ),
    TOKELAU(
        isInEU = false,
        codeA2 = "TK",
        labelPT = "TOKELAU",
        labelEN = "TOKELAU (TOKELAU ISLANDS)"
    ),
    EAST_TIMOR(
        isInEU = false,
        codeA2 = "TL",
        labelPT = "TIMOR LESTE",
        labelEN = "EAST TIMOR, DEMOCRATIC REPUBLIC OF"
    ),
    TURKMENISTAN(
        isInEU = false,
        codeA2 = "TM",
        labelPT = "TURQUEMENISTAO",
        labelEN = "TURKMENISTAN"
    ),
    TUNISIA(
        isInEU = false,
        codeA2 = "TN",
        labelPT = "TUNISIA",
        labelEN = "TUNISIA, REPUBLIC OF"
    ),
    TONGA(
        isInEU = false,
        codeA2 = "TO",
        labelPT = "TONGA",
        labelEN = "TONGA, KINGDOM OF"
    ),
    TURKEY(
        isInEU = false,
        codeA2 = "TR",
        labelPT = "TURQUIA",
        labelEN = "TURKEY, REPUBLIC OF"
    ),
    TRINIDAD_AND_TOBAGO(
        isInEU = false,
        codeA2 = "TT",
        labelPT = "TRINDADE E TOBAGO",
        labelEN = "TRINIDAD AND TOBAGO, REPUBLIC OF"
    ),
    TUVALU(
        isInEU = false,
        codeA2 = "TV",
        labelPT = "TUVALU",
        labelEN = "TUVALU (WAS PART OF GILBERT & ELLICE ISLANDS)"
    ),
    TAIWAN(
        isInEU = false,
        codeA2 = "TW",
        labelPT = "TAIWAN",
        labelEN = "TAIWAN"
    ),
    TANZANIA(
        isInEU = false,
        codeA2 = "TZ",
        labelPT = "TANZANIA, REPUBLICA UNIDA DA",
        labelEN = "TANZANIA, UNITED REPUBLIC OF"
    ),
    UKRAINE(
        isInEU = false,
        codeA2 = "UA",
        labelPT = "UCRANIA",
        labelEN = "UKRAINE"
    ),
    UGANDA(
        isInEU = false,
        codeA2 = "UG",
        labelPT = "UGANDA",
        labelEN = "UGANDA, REPUBLIC OF"
    ),
    UNITED_STATES_MINOR_OUTLYING_ISLANDS(
        isInEU = false,
        codeA2 = "UM",
        labelPT = "ILHAS MENORES DISTANTES DOS ESTADOS UNIDOS",
        labelEN = "UNITED STATES MINOR OUTLYING ISLANDS"
    ),
    UNITED_STATES_OF_AMERICA(
        isInEU = false,
        codeA2 = "US",
        labelPT = "ESTADOS UNIDOS",
        labelEN = "UNITED STATES OF AMERICA"
    ),
    URUGUAY(
        isInEU = false,
        codeA2 = "UY",
        labelPT = "URUGUAI",
        labelEN = "URUGUAY, EASTERN REPUBLIC OF"
    ),
    UZBEKISTAN(
        isInEU = false,
        codeA2 = "UZ",
        labelPT = "USBEQUISTAO",
        labelEN = "UZBEKISTAN"
    ),
    HOLY_SEE_VATICAN_CITY_STATE(
        isInEU = false,
        codeA2 = "VA",
        labelPT = "SANTA SE (CIDADE ESTADO DO VATICANO)",
        labelEN = "HOLY SEE (VATICAN CITY STATE)"
    ),
    ST_VINCENT_AND_THE_GRENADINES(
        isInEU = false,
        codeA2 = "VC",
        labelPT = "SAO VICENTE E GRANADINAS",
        labelEN = "ST. VINCENT AND THE GRENADINES"
    ),
    VENEZUELA(
        isInEU = false,
        codeA2 = "VE",
        labelPT = "VENEZUELA",
        labelEN = "VENEZUELA, BOLIVARIAN REPUBLIC OF"
    ),
    BRITISH_VIRGIN_ISLANDS(
        isInEU = false,
        codeA2 = "VG",
        labelPT = "ILHAS VIRGENS (BRITANICAS)",
        labelEN = "BRITISH VIRGIN ISLANDS"
    ),
    US_VIRGIN_ISLANDS(
        isInEU = false,
        codeA2 = "VI",
        labelPT = "ILHAS VIRGENS (ESTADOS UNIDOS)",
        labelEN = "US VIRGIN ISLANDS"
    ),
    VIET_NAM(
        isInEU = false,
        codeA2 = "VN",
        labelPT = "VIETNAME",
        labelEN = "VIET NAM, SOCIALIST REPUBLIC OF (WAS DEMOCRATIC REPUBLIC OF)"
    ),
    VANUATU(
        isInEU = false,
        codeA2 = "VU",
        labelPT = "VANUATU",
        labelEN = "VANUATU (WAS NEW HEBRIDES)"
    ),
    WALLIS_AND_FUTUNA_ISLANDS(
        isInEU = false,
        codeA2 = "WF",
        labelPT = "WALLIS E FUTUNA (ILHAS)",
        labelEN = "WALLIS AND FUTUNA ISLANDS"
    ),
    SAMOA_INDEPENDENT_STATE(
        isInEU = false,
        codeA2 = "WS",
        labelPT = "SAMOA",
        labelEN = "SAMOA, INDEPENDENT STATE OF (WAS WESTERN SAMOA)"
    ),
    ALDERNEY(
        isInEU = false,
        codeA2 = "XG",
        labelPT = "ALDERNEY",
        labelEN = "ALDERNEY"
    ),
    REPUBLIC_OF_KOSOVO(
        isInEU = false,
        codeA2 = "XK",
        labelPT = "REPUBLICA DO KOSOVO",
        labelEN = "REPUBLIC OF KOSOVO"
    ),
    YEMEN(
        isInEU = false,
        codeA2 = "YE",
        labelPT = "IEMEN",
        labelEN = "YEMEN"
    ),
    MAYOTTE(
        isInEU = false,
        codeA2 = "YT",
        labelPT = "MAYOTTE",
        labelEN = "MAYOTTE"
    ),
    SOUTH_AFRICA(
        isInEU = false,
        codeA2 = "ZA",
        labelPT = "AFRICA DO SUL",
        labelEN = "SOUTH AFRICA, REPUBLIC OF"
    ),
    ZAMBIA(
        isInEU = false,
        codeA2 = "ZM",
        labelPT = "ZAMBIA",
        labelEN = "ZAMBIA, REPUBLIC OF"
    ),
    ZIMBABWE(
        isInEU = false,
        codeA2 = "ZW",
        labelPT = "ZIMBABWE",
        labelEN = "ZIMBABWE (WAS SOUTHERN RHODESIA)"
    ),

    AUSTRIA(
        isInEU = true,
        codeA2 = "AT",
        labelPT = "AUSTRIA",
        labelEN = "AUSTRIA, REPUBLIC OF"
    ),
    BELGIUM(
        isInEU = true,
        codeA2 = "BE",
        labelPT = "BELGICA",
        labelEN = "BELGIUM, KINGDOM OF"
    ),
    BULGARIA(
        isInEU = true,
        codeA2 = "BG",
        labelPT = "BULGARIA",
        labelEN = "BULGARIA, PEOPLE'S REPUBLIC OF"
    ),
    HRVATSKA(
        isInEU = true,
        codeA2 = "HR",
        labelPT = "CROACIA",
        labelEN = "HRVATSKA (CROATIA)"
    ),
    CYPRUS(
        isInEU = true,
        codeA2 = "CY",
        labelPT = "CHIPRE",
        labelEN = "CYPRUS, REPUBLIC OF"
    ),
    CZECH_REPUBLIC(
        isInEU = true,
        codeA2 = "CZ",
        labelPT = "REPUBLICA CHECA",
        labelEN = "CZECH REPUBLIC"
    ),
    DENMARK(
        isInEU = true,
        codeA2 = "DK",
        labelPT = "DINAMARCA",
        labelEN = "DENMARK, KINGDOM OF"
    ),
    ESTONIA(
        isInEU = true,
        codeA2 = "EE",
        labelPT = "ESTONIA",
        labelEN = "ESTONIA"
    ),
    FINLAND(
        isInEU = true,
        codeA2 = "FI",
        labelPT = "FINLANDIA",
        labelEN = "FINLAND, REPUBLIC OF"
    ),
    FRANCE(
        isInEU = true,
        codeA2 = "FR",
        labelPT = "FRANCA",
        labelEN = "FRANCE, FRENCH REPUBLIC"
    ),
    GERMANY(
        isInEU = true,
        codeA2 = "DE",
        labelPT = "ALEMANHA",
        labelEN = "GERMANY"
    ),
    GREECE(
        isInEU = true,
        codeA2 = "EL", // No OSS usamos EL como código da Grécia apesar do código ISO-3166 ser GR
        labelPT = "GRECIA",
        labelEN = "GREECE, HELLENIC REPUBLIC"
    ),
    HUNGARY(
        isInEU = true,
        codeA2 = "HU",
        labelPT = "HUNGRIA",
        labelEN = "HUNGARY, HUNGARIAN PEOPLE'S REPUBLIC"
    ),
    IRELAND(
        isInEU = true,
        codeA2 = "IE",
        labelPT = "IRLANDA",
        labelEN = "IRELAND"
    ),
    ITALY(
        isInEU = true,
        codeA2 = "IT",
        labelPT = "ITALIA",
        labelEN = "ITALY, ITALIAN REPUBLIC"
    ),
    LATVIA(
        isInEU = true,
        codeA2 = "LV",
        labelPT = "LETONIA",
        labelEN = "LATVIA"
    ),
    LITHUANIA(
        isInEU = true,
        codeA2 = "LT",
        labelPT = "LITUANIA",
        labelEN = "LITHUANIA"
    ),
    LUXEMBOURG(
        isInEU = true,
        codeA2 = "LU",
        labelPT = "LUXEMBURGO",
        labelEN = "LUXEMBOURG, GRAND DUCHY OF"
    ),
    MALTA(
        isInEU = true,
        codeA2 = "MT",
        labelPT = "MALTA",
        labelEN = "MALTA, REPUBLIC OF"
    ),
    NETHERLANDS(
        isInEU = true,
        codeA2 = "NL",
        labelPT = "PAISES BAIXOS",
        labelEN = "NETHERLANDS, KINGDOM OF THE"
    ),
    POLAND(
        isInEU = true,
        codeA2 = "PL",
        labelPT = "POLONIA",
        labelEN = "POLAND, POLISH PEOPLE'S REPUBLIC"
    ),
    PORTUGAL(
        isInEU = true,
        codeA2 = "PT",
        labelPT = "PORTUGAL",
        labelEN = "PORTUGAL, PORTUGUESE REPUBLIC"
    ),
    ROMANIA(
        isInEU = true,
        codeA2 = "RO",
        labelPT = "ROMENIA",
        labelEN = "ROMANIA, SOCIALIST REPUBLIC OF"
    ),
    SLOVAKIA(
        isInEU = true,
        codeA2 = "SK",
        labelPT = "ESLOVACA (REPUBLICA)",
        labelEN = "SLOVAKIA (SLOVAK REPUBLIC)"
    ),
    SLOVENIA(
        isInEU = true,
        codeA2 = "SI",
        labelPT = "ESLOVENIA",
        labelEN = "SLOVENIA"
    ),
    SPAIN(
        isInEU = true,
        codeA2 = "ES",
        labelPT = "ESPANHA",
        labelEN = "SPAIN, SPANISH STATE"
    ),
    SWEDEN(
        isInEU = true,
        codeA2 = "SE",
        labelPT = "SUECIA",
        labelEN = "SWEDEN, KINGDOM OF"
    ),
    UNITED_KINGDOM(
        isInEU = false,
        codeA2 = "GB",
        labelPT = "REINO UNIDO",
        labelEN = "UNITED KINGDOM OF GREAT BRITAIN & N. IRELAND"
    ),
    NORTHERN_IRELAND_UK(
        isInEU = true,
        codeA2 = "XI",
        labelPT = "IRLANDA DO NORTE",
        labelEN = "NORTHERN IRELAND"
    ),
    ;

    companion object {
        fun findByA2(codeA2: String): Country? =
            values().find { it.codeA2 == codeA2 }

        val findByA2_ts = { codeA2: String -> findByA2(codeA2) }
    }
}
